import React from 'react';

/** 批量坐标输入组件 */
export default function BatchCoordinateInput({ value, onChange }) {
  return (
    <div style={{ marginBottom: 10 }}>
      <label style={{ display: 'block', marginBottom: 5, fontWeight: 'bold' }}>
        批量坐标输入（每行一个坐标）
        <span style={{ color: '#888', fontWeight: 'normal', marginLeft: 8 }}>
          支持"纬度,经度"或"经度,纬度"，系统会自动识别
        </span>
      </label>
      <textarea
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={`支持多种格式：\n39°54'15.12\"N, 116°24'26.64\"E\n39.9042, 116.4074\n119.150681, 28.077057\n39°54.252'N, 116°24.444'E\n（支持"纬度,经度"或"经度,纬度"，系统会自动识别）`}
        style={{
          width: '100%',
          height: '120px',
          padding: '8px 12px',
          border: '1px solid #ddd',
          borderRadius: '4px',
          fontSize: '14px',
          resize: 'vertical'
        }}
      />
    </div>
  );
}
